/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import { Component, OnInit } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { AuthService } from '../../services/auth/auth.service'
import { Router } from '@angular/router'
import { FormlyFieldConfig } from '@ngx-formly/core'
import { FormGroup } from '@angular/forms'

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less'],
})
export class LoginComponent implements OnInit {
    constructor(private $http: HttpClient, private authService: AuthService, private router: Router) {}
    error: boolean = false
    credentials: any
    credentialFields: FormlyFieldConfig[] = []
    customError: string = ''
    message: string = ''
    form: any

    ngOnInit(): void {
        let vm = this

        vm.error = false

        this.authService.login_strategy = 'form'
        vm.$http
            .get('/api/home/login_strategy')
            .toPromise()
            .then(function (result: any) {
                // NOTE: Even if this is changed to 'form' from SAML, the server won't allow it...
                //AuthService.login_strategy = "form";
                //AuthService.login_strategy = "saml";
                vm.authService.login_strategy = result.login_strategy
            })

        this.form = new FormGroup({})

        this.credentials = {
            username: '',
            password: '',
            rememberMe: false,
        }

        this.credentialFields = [
            {
                key: 'username',
                type: 'input',
                // ngModelElAttrs: {
                //   'autocomplete': 'current-username'
                // },
                templateOptions: {
                    type: 'text',
                    label: 'Username',
                    placeholder: 'Username',
                    required: true,
                    focus: function () {
                        return true
                    },
                },
                // expressionProperties: {
                //   'templateOptions.label': function() {
                //     return $translate('LOGIN.USERNAME').then(function(translation) {
                //       return translation;
                //     });
                //   }
                // }
            },
            {
                key: 'password',
                type: 'input',
                // ngModelElAttrs: {
                //   'autocomplete': 'current-password'
                // },
                templateOptions: {
                    type: 'password',
                    label: 'Password',
                    placeholder: 'Password',
                    required: true,
                },
                // expressionProperties: {
                //   'templateOptions.label': function() {
                //     return $translate('LOGIN.PASSWORD').then(function(translation) {
                //       return translation;
                //     });
                //   }
                // }
            },
        ]
    }

    login() {
        let vm = this
        console.log('S Login called: ' + vm.credentials.username)
        vm.customError = ''

        // Logout first.
        this.authService.login(vm.credentials.username, vm.credentials.password).then(
            function () {
                // Clear the password out
                vm.credentials.password = ''
                vm.error = false
                vm.message = ''
                if (vm.authService.authenticated()) {
                    vm.router.navigate(['app/3d'])
                } else {
                    vm.router.navigate(['app/login'])
                }
            },
            function (responseData) {
                // Clear the password out
                vm.credentials.password = ''
                vm.error = true
                vm.message = 'Login failed. Please try again'
                //$state.go('login');
            }
        )
    }
}
